(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerMediaQuery.addEventListener('change', this.boundSetHeaderHeight);
      window.addEventListener('resize', this.boundSetHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.boundSetHeaderHeight);
      this.headerMediaQuery.removeEventListener('change', this.boundSetHeaderHeight);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumbv-category-showcase"] && !Shopify.designMode) return;
  try {
    
  const initializeCategoryShowcase = (section) => {
    if (!section || section.dataset.carouselReady === 'true') return;

    const products = section.querySelector('[data-category-products]');
    const previous = section.querySelector('[data-category-previous]');
    const next = section.querySelector('[data-category-next]');

    if (!products || !previous || !next) return;

    section.dataset.carouselReady = 'true';

    const updateControls = () => {
      previous.disabled = products.scrollLeft <= 1;
      next.disabled = products.scrollLeft + products.clientWidth >= products.scrollWidth - 1;
    };

    const moveProducts = (direction) => {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      products.scrollBy({ left: direction * products.clientWidth, behavior });
    };

    previous.addEventListener('click', () => moveProducts(-1));
    next.addEventListener('click', () => moveProducts(1));
    products.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  };

  document.querySelectorAll('.lumbv-category-showcase').forEach(initializeCategoryShowcase);
  document.addEventListener('shopify:section:load', (event) => {
    initializeCategoryShowcase(event.target.querySelector('.lumbv-category-showcase'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumbv-community-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumbv-community')) {
    customElements.define(
      'lumbv-community',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('[data-community-track]');
          const previous = this.querySelector('[data-community-previous]');
          const next = this.querySelector('[data-community-next]');
          if (!track || !previous || !next) return;

          const getScrollDistance = () =>
            window.matchMedia('(max-width: 749px)').matches ? track.clientWidth - 32 : track.clientWidth * 0.8;

          previous.addEventListener('click', () => {
            track.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
          });
          next.addEventListener('click', () => {
            track.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
          });

          const dialog = this.querySelector('[data-community-dialog]');
          const dialogClose = this.querySelector('[data-community-dialog-close]');
          const dialogMedia = this.querySelector('[data-community-dialog-media]');
          const dialogRating = this.querySelector('[data-community-dialog-rating]');
          const dialogTitle = this.querySelector('[data-community-dialog-title]');
          const dialogText = this.querySelector('[data-community-dialog-text]');
          const readMoreButtons = this.querySelectorAll('[data-community-read-more]');
          const reviewTriggers = this.querySelectorAll('[data-community-read-more], [data-community-video-open]');
          let activeTrigger = null;

          const updateReadMoreButtons = () => {
            readMoreButtons.forEach((button) => {
              const text = button.parentElement.querySelector('[data-community-review-text]');
              button.hidden = !text || text.scrollHeight <= text.clientHeight + 1;
            });
          };

          const openReview = (button) => {
            if (!dialog || !dialogMedia || !dialogRating || !dialogTitle || !dialogText) return;

            const card = button.closest('.lumbv-community__card');
            const sourceMedia = card.querySelector('.lumbv-community__media video, .lumbv-community__media img');
            const rating = card.querySelector('.lumbv-community__rating');
            const title = card.querySelector('.lumbv-community__body h3');
            const review = card.querySelector('[data-community-review-text]');

            dialogMedia.replaceChildren();
            dialog.toggleAttribute('data-has-media', Boolean(sourceMedia));
            dialogMedia.hidden = !sourceMedia;

            let mediaClone = null;
            if (sourceMedia) {
              if (sourceMedia.tagName === 'VIDEO') sourceMedia.pause();
              mediaClone = sourceMedia.cloneNode(true);
              if (mediaClone.tagName === 'VIDEO') {
                mediaClone.controls = true;
                mediaClone.removeAttribute('autoplay');
              }
              dialogMedia.append(mediaClone);
            }

            dialogRating.textContent = rating ? rating.textContent.trim() : '';
            dialogRating.hidden = !rating;
            dialogTitle.textContent = title ? title.textContent.trim() : '';
            dialogText.textContent = review ? review.textContent.trim() : '';
            activeTrigger = button;
            dialog.showModal();

            if (button.matches('[data-community-video-open]') && mediaClone?.tagName === 'VIDEO') {
              mediaClone.play().catch(() => {});
            }
          };

          reviewTriggers.forEach((button) => {
            button.addEventListener('click', () => openReview(button));
          });

          dialogClose?.addEventListener('click', () => dialog.close());
          dialog?.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
          dialog?.addEventListener('close', () => {
            dialogMedia?.replaceChildren();
            if (activeTrigger?.isConnected) activeTrigger.focus();
          });

          this.communityResizeObserver = new ResizeObserver(updateReadMoreButtons);
          this.communityResizeObserver.observe(track);
          document.fonts?.ready.then(updateReadMoreButtons);
          requestAnimationFrame(updateReadMoreButtons);
        }

        disconnectedCallback() {
          this.communityResizeObserver?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumbv-tracking-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumbv-tracking')) {
    customElements.define('lumbv-tracking', class extends HTMLElement {
      connectedCallback() {
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        tabs.forEach((tab) => tab.addEventListener('click', () => {
          tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
          panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        }));
        this.querySelector('[data-order-form]')?.addEventListener('submit', (event) => {
          event.preventDefault();
          const notice = this.querySelector('[data-order-notice]');
          notice.hidden = false;
          notice.focus();
        });
        this.querySelector('[data-tracking-form]')?.addEventListener('submit', (event) => {
          event.preventDefault();
          const value = new FormData(event.currentTarget).get('tracking_number')?.trim();
          if (value) window.open(`https://www.17track.net/en?nums=${encodeURIComponent(value)}`, '_blank', 'noopener');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
